module.exports = __webpack_public_path__ + "static/media/appLogo.32830b06.svg";